import {
  Box, Container,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import appRoutes from '../../../services/AppRoutes'
import UseTranslation from '../../../hooks/UseTranslation'
import loginBackSvg from '../../../images/loginBackSvg.svg'
import SEO from '../../../components/PageHelpers/SEO'
import { ReactComponent as Inbox } from '../../../images/Inbox.svg'
import {
  retrieveNotificationInboxWithQueries,
} from '../../../redux/features/notifications/notificationInbox/notificationInboxThunk'
import InboxCardList from './InboxCardList'
import LinkBtn from '../../../components/Buttons/LinkBtn'
import SearchBarToggle from '../../../components/PageHelpers/SearchBarToggle'
import SelectRequest from './SelectRequest'
import TitleWithCountV2 from '../../../components/PageHelpers/TitleWithCountV2'
import SearchBarV2 from '../../../components/PageHelpers/SearchBarV2'

const Index = () => {
  const { t } = UseTranslation()
  const [searchBarExpanded, setSearchBarExpanded] = useState(false)
  const [selectionMode, setSelectionMode] = useState(false)
  const [selectedCards, setSelectedCards] = useState([])

  const dispatch = useDispatch()
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  useEffect(() => {
    dispatch(retrieveNotificationInboxWithQueries({ resetQueries: true }))
  }, [])

  return (
    <Box sx={styles.root}>
      <SEO title={t?.Inbox} description={t?.Inbox} />
      <Container maxWidth={false} sx={styles.container}>
        <Box sx={styles.wrapperContainer}>
          <Box sx={styles.headerContainer}>
            {!searchBarExpanded && (
            <TitleWithCountV2
              title={t?.Inbox}
              icon={<Inbox />}
              iconSize="xl"
              iconColor="warning.dark"
              textVariant="heading2"
              customStyle={styles.headerTitle}
            />
            )}
            {isXsScreen && (
              <SearchBarToggle
                searchPlaceholder={t?.['Search By Request Details']}
                actionToDispatch={retrieveNotificationInboxWithQueries}
                expandedState={searchBarExpanded}
                setExpandedState={setSearchBarExpanded}
                sendQueryAsObject
                actionProps={{ pageNumber: 0 }}
                customStyle={styles.searchBarToggle}
              />
            )}
          </Box>
          {!selectionMode && (
            <Box sx={styles.btnContainer}>
              <LinkBtn
                to={`${appRoutes.ActionHistory}`}
                name={(
                  <Box sx={styles.linkTitle}>
                    <Typography>{t?.['View Action History']}</Typography>
                    <ArrowForwardIosIcon />
                  </Box>
              )}
                customStyle={styles.linkBtn}
              />
            </Box>
          )}
        </Box>
        {!isXsScreen && (
        <SearchBarV2
          actionToDispatch={retrieveNotificationInboxWithQueries}
          searchPlaceholder={t?.['Search By Request Details']}
          sendQueryAsObject
          customStyles={styles.searchBar}
          actionProps={{ pageNumber: 0 }}
        />
        )}
        <SelectRequest
          selectionMode={selectionMode}
          setSelectionMode={setSelectionMode}
          selectedCards={selectedCards}
          setSelectedCards={setSelectedCards}
        />
        <InboxCardList
          selectionMode={selectionMode}
          selectedCards={selectedCards}
          setSelectedCards={setSelectedCards}
        />

      </Container>
      <Box component="img" src={loginBackSvg} alt="login img" sx={styles.backSvg} />
    </Box>
  )
}

const styles = {
  root: {
    marginTop: { xs: '-10px', sm: '-29px' },
    paddingInline: { xs: '10px !important', sm: '18px !important', md: '24px !important' },
  },
  container: {
    padding: { xs: '0px !important', sm: '0px !important' },
    width: { xs: '100%', sm: 'unset' },

  },
  wrapperContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px',
    backgroundColor: 'background.paper',
    height: { xs: '56px', sm: '88px' },
    margin: {
      xs: '0px', sm: '0px 10px 10px 10px', md: '0px 0px 20px 0px', lg: '0px 0px 20px 0px',
    },
    '& .searchIcon': {
      width: '27px',
      height: '27px',
    },
  },
  headerTitle: {
    marginBottom: { xs: '0px !important', sm: '10px' },
    display: 'flex',
    alignItems: { xs: 'center', md: 'flex-end' },
    gap: '10px',
    '& h5': {
      fontFamily: 'Avenir 85 Heavy',
      fontWeight: 500,
      fontSize: { xs: '16px', sm: '24px' },
      lineHeight: { xs: '20.15px', sm: '27.9px' },
      paddingTop: '0px !important',
    },

  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '40px',
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px',
    backgroundColor: 'background.paper',
    p: { xs: 1, sm: '20px', md: '25px' },
  },

  linkTitle: {
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    '& svg': {
      width: { xs: '15px', sm: '12px' },
      height: { xs: '15px', sm: '12px' },
      paddingLeft: '20px',
    },
  },
  btnContainer: {
    position: { xs: 'fixed', sm: 'unset' },
    bottom: 0,
    zIndex: 100,
    right: 0,
    width: { xs: '100%', sm: 'fit-content' },
    border: { xs: '1px solid grey.200', sm: 'none' },
    backgroundColor: 'background.paper',
    padding: '10px',
    marginRight: { xs: '0px', sm: '0px' },
  },
  linkBtn: {
    boxSizing: 'border-box',
    width: { xs: '95%', sm: '100%' },
    maxWidth: { xs: '100%', sm: 'fit-content' },
    height: { xs: '32px', sm: '40px' },
    color: 'text.main',
    textTransform: 'none',
    mx: { xs: 'auto', sm: '0px' },
    marginRight: { xs: '0px !important', sm: '20px !important' },
    '& p': {
      fontSize: { xs: '12px', sm: '14px' },
      maxWidth: { xs: '196px', sm: '190px' },
      paddingLeft: { xs: '0px', sm: '10px' },
    },
  },
  backSvg: {
    position: 'fixed',
    unset: 0,
    zIndex: -1,
  },
  searchBarToggle: {
    '& .MuiTextField-root': {
      marginBottom: '-20px',
    },
    '& img': {
      marginBottom: '-10px',
    },
  },
  searchBar: {
    marginBottom: '10px !important',
    marginTop: '30px',
    '& svg': {
      width: '25px !important',
      height: '25px !important',
    },
  },
}

export default Index
